export enum StepStatusEnum {
  Active = 10,
  Pending = 20,
  Completed = 30,
}

export enum ProductShoppingFilterEnum {
  TestTakerStudyMaterial = 1,
  PrintMaterial = 2,
  TeacherResource = 3,
  CELPIPGeneral = 5,
  CELPIPLS = 7
}

export enum ProductShoppingSectionEnum {
  FEATUREDP_RODUCTS = 1,
  ONLINE_COURSES = 2,
  CELPIP_GENERAL_PAPERBACK = 3,
  CELPIP_GENERAL_ONLINE = 4,
  CELPIP_GENERAL_LS_PAPERBACK = 5,
  CELPIP_GENERAL_LS_ONLINE = 6,
  OTHER_CELPIP_PRODUCTS = 7,
  CELPIP_TEACHER_RESOURCES = 8,
  CELPIP_GENERAL_PRACTICE_TESTS = 9,
  CELPIP_GENERAL_LS_PRACTICE_TESTS = 10,
  EBOOKS = 11
}

export enum ProductSortTypeOrderEnum {
  PopularityHighToLow = 1,
  PopularityLowToHigh = 2,
  PriceHighToLow = 3,
  PriceLowToHigh = 4
}

export enum PageOnlineStepEnum {
  ProofOfIdentity = 1,
  Photo = 2,
  ID = 3,
  ScoreReport = 4,
  TestSummary = 5,
  StudyMaterial = 6,
  OrderSummary = 7,
  OrderComplete = 8
}

export enum RegWorkflowEnum {
  CELPIP = 1,
  CAEL = 2,
  WEB_DELIVERY = 3,
  CAEL_SAFT = 4
}

// the code below is generated from Platform.sln
export enum AffiliateLinkActivityTypeEnum {
  CreateAccount = 1,
  Purchase = 2,
  Click = 3
}

export enum BrandEnum {
  AGNOSTIC = 0,
  CELPIP = 1,
  CAEL = 2,
  LPI = 3
}
export enum ComponentTypeEnum {
  Listening = 1,
  Reading = 2,
  Writing = 3,
  Speaking = 4,
  Nonspecific = 5,
  Overall = 6,
  DSCScore = 7,
  SSSCore = 8,
  EUScore = 9,
  Essay = 10,
  Level = 11
}
export enum CountryEnum {
  Canada = 38,
  China = 44,
  India = 101,
  Mexico = 140,
  USA = 225,
  UnitedStates = 225,
  PHILIPPINES = 170,
  UNITED_ARAB_EMIRATES = 223,
  Unknown = 999
}
export enum DeliveryMethodEnum {
  TestCentre = 1,
  Online = 2
}
export enum IdDocTypeEnum {
  Passport = 1,
  NationalIdentityCard = 2,
  MilitaryIdentification = 7,
  CertificateOfCitizenship = 8,
  DriverLicense = 10,
  CanadianPermanentResidentCard = 12,
  CanadianRefugeeProtectionClaimantDocument = 19,
  ProvincialHealthCard = 20,
  CSICMembershipCard = 21,
  OperatorsLicence = 22,
  ProvincialIdentificationCard = 23,
  CanadianCitizenshipCard = 24,
  CanadianTravelDocument = 25,
  StudentID = 26,
  EmiratesIDCard = 27,
  GoCard = 28,
  UnitedStatesPassportCard = 29,
  ChinaResidentIDCard = 30,
  ChinaHongkongResidentIDCard = 31,
  ChinaMacauResidentIDCard = 32,
  ChinaIDCardforHongkongMacauResident = 33,
  ChinaMainlandTravelPermitforTaiwanResidents = 34,
  ChinaIDCardforTaiwanResidentID = 35,
  RefugeeTravelDocument = 36,
  CertificateofIdentity = 37,
  CertificateOfIndianStatus = 38,
  ChinaFPRID = 39,
  ComputerizedNationalIdentityCard = 40
}
export enum InvoiceStatusEnum {
  Pending = 5,
  Closed = 10,
  Issued = 15,
  Processed = 20
}
export enum ProductTypeEnum {
  TestRegistration = 1,
  PhysicalProduct = 2,
  ElectronicProductEBook = 3,
  TransferService = 4,
  ProductBundle = 5,
  ShippingAndHandling = 6,
  ElectronicProductOnline = 8,
  OfficialScoreReport = 9,
  ReEvaluationService = 10,
  ExpressScoreShippingService = 11,
  ExpressRatingService = 12,
  FeedbackService = 13,
  ProductOption = 14,
  OnlineProgram = 15,
  ElectronicProductFile = 17,
  VoucherProduct = 18,
  HardcopyScoreReportShipping = 19,
  RetakeTestRegistration = 20
}
export enum RegStatusEnum {
  RegistrationPending = 1,
  RegistrationInShoppingCart = 2,
  RegistrationActive = 3,
  RegistrationCancelled = 4,
  RegistrationRefunded = 5,
  RegistrationNotAvailable = 7,
  RegistrationIgnored = 8,
  RegistrationManualApprovalRequired = 9,
  TestTaken = 100,
  NoShowMedical = 101,
  NoShowExpiredID = 102,
  NoShowNoID = 103,
  NoShowWrongID = 104,
  NoShow = 105,
  RefusedEntry = 110,
  ScorePublished = 200,
  ScoreIncompleteOrMissing = 201,
  ScoreInvalidated = 202,
  ScoreUnderReview = 203
}
export enum ScannedDocumentStatusEnum {
  Submitted = 1,
  Rejected = 2,
  Approved = 3,
  Pending = 4
}
export enum SurveyChoiceTypeEnum {
  RadioButton = 1,
  RadioButtonWithTextBox = 2,
  RadioButtonTriggerChildQuestion = 3,
  RadioButtonBlockSubmit = 4,
  CheckBox = 5,
  CheckBoxWithTextBox = 6,
  CheckBoxTriggerChildQuestion = 7,
  DropDownChoice = 8
}
export enum SurveyQuestionTypeEnum {
  RadioButtonMC = 1,
  DropDownMC = 2,
  CheckBoxMC = 3
}
export enum TestSessionTypeEnum {
  Regular = 1,
  HighSchool = 2
}
export enum TestTypeEnum {
  CELPIP_G = 5,
  CELPIP_LS = 7,
  DEMO_G_2014 = 8,
  PILOT_G_2014 = 10,
  PRETEST_G = 11,
  PRETEST_LS = 12,
  RESEARCH_G = 13,
  CELPIP_SAFT = 14,
  CAEL = 20,
  CAEL_PLACEMENT = 21,
  CAEL2 = 22,
  SAFT = 23,
  CAEL_CE_DEMO = 24,
  LPI = 25,
  CAEL_SAFT = 26
}
export enum TestPurposeEnum {
  CICImmigrationAndPR = 1,
  Others = 2,
  CICCitizenship = 3,
  Pretest = 4,
  SaskatchewanRealtors = 5,
  AlbertaHumanServicesChildCare = 6,
  NorQuestCollegeELP = 7,
  ForAcademicPurposes = 8,
  BCHealthCareAssistant = 10,
  Employment = 11,
  AlbertaInstituteOfMassage = 12,
  RECA = 13,
  CICC = 14,
  ArmedForces = 15,
  ForOtherPurposes = 16,
  RealEstateCouncilofBC = 17,
  GEMS = 20,
  AdmissionToInstitution = 22,
  IRCCParent = 25,
  CollegeOfPhysiciansAndSurgeons = 31,
  CollegeOfDenturists = 32,
  // the line below is added manually
  UniversityAdmissions = 28,
  PurposeNotIncluded = 9
}
export enum OrderStatusEnum {
  Pending = 1,
  PaymentApproved = 10,
  PaymentRejected = 11,
  Cancelled = 20
}
export enum RegBlobDataTypeEnum {
  PictureFromRegistration = 1,
  Signature = 2,
  ScannedId1 = 3,
  ScannedId2 = 4,
  ScannedId3 = 5,
  ScannedId4 = 6,
  ScannedId5 = 7,
  RegistrationForm = 8,
  PictureFromTestCentre = 9,
  Document1 = 10,
  Document2 = 11,
  Document3 = 12,
  Document4 = 13,
  Document5 = 14,
  AudioSample = 15,
  VideoSample = 16,
  OnlineScannedDocument = 17,
  OnlineScannedDocument2 = 18
}

export enum ScoreFlagTypeEnum {
  MissingComponents = 1,
  Plagiarism = 2,
  SpeakingTech = 3,
  WritingTech = 4,
  RatingAssignedZero = 5,
  RatingAssignedNine = 6,
  General = 7,
  IdentityDocuments = 8,
  RatingReview = 9,
  TestTakerComplaint = 10,
  RequiresScoreMerge = 11,
  RequiresReequate = 12,
  ManualReevaluation = 13,
  SpecialAccomodation = 14,
  TestDeliveryMonitor = 15,
  LRMissingResponses = 16,
  SpeakingMissingResponses = 17,
  WritingMissingResponses = 18,
  RemoveSpeakingResponses = 19,
  RatingAssignedNone = 20,
}

